/* tslint:disable */
/* eslint-disable */
export enum WorkNewsReadConfirmationReminderChannelEnum {
  PushOrSms = 'PUSH_OR_SMS',
  Push = 'PUSH',
  Sms = 'SMS'
}
